// 파트너: 로그아웃 → 로그인 → 결제페이지 복귀 후 토스창을 1회 자동 오픈하기 위한 플래그.
// PartnerLogin 이 세팅하고, PartnerTossButton 이 복귀 시 소비(1회).
// 토스/소셜 OAuth 의 전체 페이지 리다이렉트 왕복에도 sessionStorage 는 보존됨.
const PARTNER_AUTOPAY_KEY = "partner.autopay";

export const setPartnerAutopay = () => {
  try {
    sessionStorage.setItem(PARTNER_AUTOPAY_KEY, "1");
  } catch {}
};

export const consumePartnerAutopay = (): boolean => {
  try {
    if (sessionStorage.getItem(PARTNER_AUTOPAY_KEY) === "1") {
      sessionStorage.removeItem(PARTNER_AUTOPAY_KEY);
      return true;
    }
  } catch {}
  return false;
};
